//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Selector from './Selector.vue';
import ApartmentCard from '../partials/ApartmentCard.vue';
import ApartmentPopup from '../partials/ApartmentPopup.vue';
import ApartmentForm from '../partials/ApartmentForm.vue';
import PriceHistoryPopup from '../partials/PriceHistoryPopup.vue';

export default {
  name: 'ApartmentsList',
  props: ['url'],
  components: {
    'apartment-card': ApartmentCard,
    'apartment-popup': ApartmentPopup,
    'apartment-form': ApartmentForm,
    'apartment-selector': Selector,
    'price-history-popup': PriceHistoryPopup,
  },
  data: function() {
    return {
      sheet: [],
      isFormVisible: false,
      contactFormApartment: null,
      status: 'wolne',
      apartments: [],
      filteredApartments: [],
      limit: 6,
      initialLimit: 6,
      selected: null,
      popupVisible: false,
      showPriceHistoryPopup: false,
      priceHistoryData: {
        apartmentId: '',
        investmentId: '',
      },
    };
  },

  beforeMount() {
    const sheetID = '1cahNt8XTjmGbQXNEVWgkJFLwJL-caZmUTuW44hB56oQ';
    const sheetName = 'Arkusz1';
    const apiKey = 'AIzaSyBGgkWKuM1s8-0dT3sU8eNEqMdUoS9JFkU';

    fetch(
      'https://sheets.googleapis.com/v4/spreadsheets/' +
        sheetID +
        '/values/' +
        sheetName +
        '?key=' +
        apiKey
    )
      .then(res => res.json())
      .then(json => {
        const keys = json.values[0];
        const values = json.values.slice(1);
        const apartments = values.map(array => {
          const object = {};
          keys.forEach((key, i) => (object[key] = array[i]));
          return object;
        });
        console.log('Apartments', apartments);
        this.apartments = apartments;
        this.filteredApartments = apartments;
        this.filterApartments();
      });
  },

  methods: {
    setStatus(status) {
      this.status = status;
      this.limit = this.initialLimit;
      this.filterApartments();
    },
    increaseLimit() {
      this.limit = this.limit + this.initialLimit;
      this.filterApartments();
    },
    filterApartments() {
      if (this.status) {
        this.filteredApartments = this.apartments.filter(apartment => {
          return apartment.status.toLowerCase() == this.status;
        });
      } else {
        this.filteredApartments = this.apartments;
      }
    },
    handleApartmentSelection(load) {
      document
        .getElementById('apartmentList')
        .classList.remove('decorated__content');
      this.popupVisible = true;
      this.selected = this.apartments.filter(item => item.id == load)[0];
      window.ga(
        'send',
        'event',
        'Wybór Domu',
        'Poup Aktywowany: ' + this.selected.id
      );
    },
    handlePopupClose() {
      document
        .getElementById('apartmentList')
        .classList.add('decorated__content');
      this.popupVisible = false;
    },
    handleFormOpen(id) {
      this.isFormVisible = true;
      this.contactFormApartment = id;
      window.ga(
        'send',
        'event',
        'Wybór Domu',
        'Formularz Kontaktowy Otwarty: ' + id
      );
    },
    handleFormClose() {
      this.isFormVisible = false;
    },
    handleShowPriceHistory(data) {
      // Only remove decorated__content if no other popup is currently active
      if (!this.popupVisible) {
        document
          .getElementById('apartmentList')
          .classList.remove('decorated__content');
      }
      this.priceHistoryData = data;
      this.showPriceHistoryPopup = true;
    },
    closePriceHistoryPopup() {
      this.showPriceHistoryPopup = false;
      // Only add back decorated__content if no other popup is currently active
      if (!this.popupVisible) {
        document
          .getElementById('apartmentList')
          .classList.add('decorated__content');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/components/ApartmentsList.vue